export const SYNTHETIC_ROW_IDS = {
    DASHBOARD: '__DASHBOARD__',
    QUICK_AGENTS: '__QUICK_AGENTS__',
    SETTINGS: '__SETTINGS__',
    HELP: '__HELP__',
    AUTOMATIONS: '__AUTOMATIONS__',
};
//# sourceMappingURL=types.js.map